// File di configurazione per le chiamate API

import axios from 'axios';

// Creazione dell'istanza axios con configurazione di base
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL || 'https://recupmanager.studiohard.it',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor per le richieste
api.interceptors.request.use(
    (config) => {
        // Aggiungi il token di autenticazione alle richieste se presente
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor per le risposte
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Gestisci gli errori globalmente
        if (error.response?.status === 401) {
            // Token scaduto o non valido, reindirizza al login
            localStorage.removeItem('authToken');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
